import { render, staticRenderFns } from "./DeleteDialog.vue?vue&type=template&id=3b72fa40&scoped=true"
import script from "./DeleteDialog.vue?vue&type=script&lang=js"
export * from "./DeleteDialog.vue?vue&type=script&lang=js"
import style0 from "./DeleteDialog.vue?vue&type=style&index=0&id=3b72fa40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b72fa40",
  null
  
)

export default component.exports